import { render, staticRenderFns } from "./partnerListDetail.vue?vue&type=template&id=498f8129&scoped=true&"
import script from "./partnerListDetail.vue?vue&type=script&lang=js&"
export * from "./partnerListDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498f8129",
  null
  
)

export default component.exports